import LocalizedStrings from 'react-localization';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import * as core from './core';
import * as archiviazione from './archiviazione';
import * as contributi from './contributi';

export interface ApplicationState {
    [core.constants.NAME]: core.CoreState,    
    [archiviazione.constants.NAME]: archiviazione.ArchiviState,
    [contributi.constants.NAME]: contributi.ContributiState,
}

export const reducers = {
    [core.constants.NAME]: core.reducer,
    [archiviazione.constants.NAME]: archiviazione.reducer,
    [contributi.constants.NAME]: contributi.reducer,
}

export const strings = new LocalizedStrings({
    it: {
        [core.constants.NAME]: core.localization.italiano,
        [archiviazione.constants.NAME]: archiviazione.localization.italiano,
        [contributi.constants.NAME]: contributi.localization.italiano,
    },
    en: {
        [core.constants.NAME]: core.localization.inglese,
        [archiviazione.constants.NAME]: archiviazione.localization.inglese,
        [contributi.constants.NAME]: contributi.localization.inglese,
    }
})

export const routes = {
    [core.constants.NAME]: core.constants.routes,
    [archiviazione.constants.NAME]: archiviazione.constants.routes,
    [contributi.constants.NAME]: contributi.constants.routes,
}

export type NEiTThunk<R, A extends Action> = ThunkAction<R, ApplicationState, unknown, A>;